module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header1":"Welcome to","header2":"Electronic Submission Hub"},"zh_hk":{"header1":"歡迎瀏覽","header2":"電子資料呈交及處理系統"},"zh_cn":{"header1":"欢迎浏览","header2":"电子资料呈交及处理系统"}}')
  delete Component.options._Ctor
}
